export const es_income = {
    title: 'Estado de Cuenta',
    label_price: 'Prezzo d\'acquisto',
    label_tax: 'Tassa Registro',
    label_fix_tax: 'Tasse fisse',
    label_renovation_cost: 'Ristrutturazione',
    label_unexpected: 'Imprevisti',
    label_home_staging: 'Home Staging',
    label_realestate: '% Agente',
    label_costs: 'Costi',
    label_revenue: 'Ricavi',
    label_profit: 'Profit',
    label_cash_difference: 'Contanti',
    label_roi: 'ROI',
    label_roe: 'ROE',
    label_better_scenario:'Migliore',
    label_medium_scenario: 'Medio',
    label_worse_scenario: 'Peggiore'


};